import React, { memo } from 'react';
import { DateTimePickerModal } from '@/components';
import { AnchorRect } from '@/hooks/common/useAnchoredPosition';

type PickerKey = 'start' | 'end' | 'publish';

interface Props {
  DateTimePicker: any;
  datePickerState: any;
  onDateChange: (event: any, selectedDate?: Date) => void;
  onConfirm: (pickerType: PickerKey) => void;
  onCancel: () => void;
  onModeChange: (mode: 'date' | 'time') => void;
  enabledPickers: Partial<Record<PickerKey, boolean>>;
  titles?: Partial<Record<PickerKey, string>>;
  webAnchor: AnchorRect | null;
}

export const AdminDateTimePickers: React.FC<Props> = memo(({ 
  DateTimePicker,
  datePickerState,
  onDateChange,
  onConfirm,
  onCancel,
  onModeChange,
  enabledPickers,
  titles,
  webAnchor,
}) => {
  return (
    <>
      {enabledPickers.start && (
        <DateTimePickerModal
          DateTimePicker={DateTimePicker}
          datePickerState={datePickerState}
          onDateChange={onDateChange}
          onConfirm={onConfirm}
          onCancel={onCancel}
          pickerType="start"
          title={titles?.start || 'Start Time'}
          onModeChange={onModeChange}
          webAnchor={webAnchor}
        />
      )}
      {enabledPickers.end && (
        <DateTimePickerModal
          DateTimePicker={DateTimePicker}
          datePickerState={datePickerState}
          onDateChange={onDateChange}
          onConfirm={onConfirm}
          onCancel={onCancel}
          pickerType="end"
          title={titles?.end || 'End Time'}
          onModeChange={onModeChange}
          webAnchor={webAnchor}
        />
      )}
      {enabledPickers.publish && (
        <DateTimePickerModal
          DateTimePicker={DateTimePicker}
          datePickerState={datePickerState}
          onDateChange={onDateChange}
          onConfirm={onConfirm}
          onCancel={onCancel}
          pickerType="publish"
          title={titles?.publish || 'Publish Time'}
          onModeChange={onModeChange}
          webAnchor={webAnchor}
        />
      )}
    </>
  );
});

AdminDateTimePickers.displayName = 'AdminDateTimePickers';


